// extracted by mini-css-extract-plugin
module.exports = {"buttons":"SetupRecs_buttons__308xH","page":"SetupRecs_page__1Abgf"};